import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OficinaRepository } from 'src/app/domain/service/oficina/oficina-repository';
import { Oficina } from '@model/oficina/oficina';

/**
 * Adaptador HTTP: HttpOficinaRepository
 *
 * Implementa el puerto OficinaRepository para comunicación HTTP con backend.
 * Realiza llamadas REST al backend Spring Boot (OficinaController).
 *
 * Arquitectura Hexagonal:
 * - Este adaptador está en infraestructura
 * - Implementa el puerto OficinaRepository del dominio
 *
 * Backend: 580-girop_servicios-ms (puerto 8080)
 *
 * @author Sura - Migración GWT a Spring Boot
 */
@Injectable({ providedIn: 'root' })
export class HttpOficinaRepository implements OficinaRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/oficinas`;

  async obtenerOficinas(): Promise<Oficina[]> {
    return firstValueFrom(
      this.http.get<Oficina[]>(this.baseUrl)
    );
  }
}
